import { PhoneNumberE164 } from "@sp-crm/core";
import { Panel } from "components/ui/panel/panel";
import { PanelType } from "components/ui/panel/panel-type";
import React from "react";
import { SmsConversation } from "./sms-conversation";

interface SendSmsPanelProps {
    isOpen: boolean;
    onDismiss: () => void;
    recipient: PhoneNumberE164;
}

export const SendSmsPanel: React.FC<SendSmsPanelProps> = props => {
    const { isOpen, onDismiss, recipient } = props;

    return (
        <Panel
            isOpen={isOpen}
            onDismiss={onDismiss}
            type={PanelType.large}
            headerText="Send SMS">
            <SmsConversation recipient={recipient} onClose={onDismiss} />
        </Panel>
    );
};
